import { render, staticRenderFns } from "./MovimentacaoEstoqueDepartamento.vue?vue&type=template&id=06a0d57c&scoped=true"
import script from "./MovimentacaoEstoqueDepartamento.vue?vue&type=script&lang=js"
export * from "./MovimentacaoEstoqueDepartamento.vue?vue&type=script&lang=js"
import style0 from "./MovimentacaoEstoqueDepartamento.vue?vue&type=style&index=0&id=06a0d57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a0d57c",
  null
  
)

export default component.exports